module.exports = __webpack_public_path__ + "static/media/PCD220C.07794710.png";